module.exports = __webpack_public_path__ + "static/media/iconStudentsYellow.05154206.svg";